export const runSystemIdentificationPersistence = async ({
  request,
  onSuccess,
  refresh,
}) => {
  try {
    await request();
    onSuccess();
    await refresh();
    return null;
  } catch (error) {
    return error;
  }
};

